/** @format */
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { ProductComparisonItemHeader } from '../../product-comparison-item.styles';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const ProductComparisonItemOutOfStockHeader = styled(
    ProductComparisonItemHeader
)`
    ${theme.typography.body_small}
    grid-template-columns: 1fr;
    justify-items: center;

    .product-comparison-item-out-of-stock-message {
        text-align: center;
        margin-bottom: var(--layout-spacing-24);

        p {
            margin-bottom: 0;
        }
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
